export default __webpack_public_path__ + "static/media/india-2021.70070437.png";